import { ContactRole } from 'enums';
import { useSearchContact } from 'hooks';

export interface UseGetContactsProps {
  insuredOrganizationId?: string | null;
}

export default function useGetContacts({ insuredOrganizationId }: UseGetContactsProps) {
  const { items: retailerContacts, isLoading: retailersIsLoading } = useSearchContact({
    filter: { role: ContactRole.Retailer },
  });

  const { items: insuredContacts, isLoading: insuredIsLoading } = useSearchContact({
    filter: { role: ContactRole.Insured, organizationId: insuredOrganizationId || undefined },
  });

  const isContactsLoading = retailersIsLoading || insuredIsLoading;

  return {
    retailerContacts,
    insuredContacts,
    isContactsLoading,
  };
}
